import styled, { keyframes } from "styled-components";

/* Water-ripple shimmer: a soft aqua highlight sweeps diagonally across the
   surface, echoing how light moves across the face of water. */
const waterShimmer = keyframes`
  0% {
    transform: translateX(-120%);
  }
  100% {
    transform: translateX(120%);
  }
`;

/* Subtle breathing pulse on the base so the whole surface feels alive. */
const waterBreathe = keyframes`
  0%, 100% {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.04);
  }
`;

export const Skeleton = styled.div`
  position: relative;
  overflow: hidden;
  isolation: isolate;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.22);
  background:
    radial-gradient(
      120% 90% at 20% 0%,
      rgba(var(--glass-white-rgb), 0.9) 0%,
      rgba(var(--glass-pale-rgb), 0.78) 45%,
      rgba(var(--glass-pale-rgb), 0.66) 100%
    ),
    linear-gradient(
      180deg,
      rgba(var(--glass-white-rgb), 0.76) 0%,
      rgba(var(--glass-pale-rgb), 0.62) 100%
    );
  backdrop-filter: blur(8px) saturate(140%);
  -webkit-backdrop-filter: blur(8px) saturate(140%);
  box-shadow:
    0 6px 14px rgba(var(--color-brand-500-rgb), 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.85),
    inset 0 -2px 6px rgba(var(--color-brand-200-rgb), 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${waterBreathe} 3.2s ease-in-out infinite;

  /* Top specular sheen — reads as light catching the water surface */
  &::before {
    content: "";
    position: absolute;
    top: 1px;
    left: 10%;
    right: 10%;
    height: 12px;
    border-radius: 999px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.55) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    filter: blur(2px);
    pointer-events: none;
    z-index: 1;
  }

  [data-theme="dark"] &::before {
    opacity: 0;
  }

  /* Water-ripple shimmer sweep */
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(
      110deg,
      rgba(var(--color-brand-300-rgb), 0) 0%,
      rgba(var(--color-brand-300-rgb), 0.18) 35%,
      rgba(var(--color-brand-400-rgb), 0.42) 50%,
      rgba(var(--color-brand-300-rgb), 0.18) 65%,
      rgba(var(--color-brand-300-rgb), 0) 100%
    );
    pointer-events: none;
    will-change: transform;
    animation: ${waterShimmer} ${({ $animationTime }) =>
`${$animationTime ?? 1.8}s`}
      ease-in-out infinite;
  }
`;
